"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInnerText = exports.StyledCheckboxRoot = exports.StyledCheckboxWrapper = void 0;
const react_checkbox_1 = require("@radix-ui/react-checkbox");
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
exports.StyledCheckboxWrapper = styled_components_1.default.div `
    position: relative;
    display: flex;

    &:focus-within {
        ${({ disabled, theme }) => {
    if (disabled || theme !== "bordered") {
        return null;
    }
    return `
                border: 1px solid ${tokens_1.COLOURS.greyscale.night};
            `;
}}
    }

    ${({ theme, disabled, $checked, $size }) => {
    if (theme === "bordered") {
        if (disabled) {
            return `
                background-color: ${tokens_1.COLOURS.greyscale.cloud};
                padding: ${tokens_1.BUTTON_FORM_FIELDS_PADDING.text[$size]};
                border-radius: ${tokens_1.BORDERS.radius};
                border: ${tokens_1.BORDERS.normal.silver};
                color: ${tokens_1.COLOURS.greyscale.white};
            `;
        }
        if ($checked) {
            return `
                background-color: ${tokens_1.COLOURS.primary.blue[10]};
                border: 1px solid ${tokens_1.COLOURS.primary.blue[100]};
                padding: ${tokens_1.BUTTON_FORM_FIELDS_PADDING.text[$size]};
                border-radius: ${tokens_1.BORDERS.radius};
                `;
        }
        return `
            padding: ${tokens_1.BUTTON_FORM_FIELDS_PADDING.text[$size]};
            border-radius: ${tokens_1.BORDERS.radius};
            border: ${tokens_1.BORDERS.normal.silver};
            background-color: ${tokens_1.COLOURS.greyscale.white};
        `;
    }
    return null;
}}

    .custom-checkbox-label {
        position: relative;
        align-items: center;
        padding-left: ${tokens_1.SIZES[1]};
        user-select: none;

        ${({ theme }) => {
    if (theme === "bordered")
        return `
            display: flex;
            width: 100%;
            `;
    return `
                display: inline-flex;
                width: auto;
            `;
}}

        ${({ disabled, $checked }) => {
    if (disabled || $checked) {
        return `
                    color: ${disabled
            ? tokens_1.COLOURS.greyscale.stone
            : tokens_1.COLOURS.greyscale.night};
                    // Extend the colour to all the possible JSX components passed
                    * {
                        color: ${disabled ? tokens_1.COLOURS.primary.red : tokens_1.COLOURS.primary.red};
                        fill: ${disabled ? tokens_1.COLOURS.primary.red : tokens_1.COLOURS.primary.red};
                    }
                `;
    }
    return `
                * {
                    color: ${tokens_1.COLOURS.greyscale.night};
                    fill: ${tokens_1.COLOURS.greyscale.night};
                }
            `;
}}
    }
`;
exports.StyledCheckboxRoot = (0, styled_components_1.default)(react_checkbox_1.Root) `
    background-color: ${tokens_1.COLOURS.greyscale.white};
    width: ${tokens_1.SIZES[2]};
    height: ${tokens_1.SIZES[2]};
    padding: 0;
    border: ${tokens_1.BORDERS.normal.stone};
    border-radius: ${tokens_1.SIZES[0.25]};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    line-height: normal;

    &:hover {
        ${({ disabled, checked }) => {
    if (disabled) {
        return null;
    }
    if (checked) {
        return `
                    background-color: ${tokens_1.COLOURS.primary.blue[130]}
                `;
    }
    return `
                border: 2px solid ${tokens_1.COLOURS.greyscale.metal};
           `;
}}
    }

    &:focus&:focus,
    &:focus-visible {
        ${({ disabled }) => {
    if (disabled) {
        return null;
    }
    return `
                border: ${tokens_1.BORDERS.normal.metal};
                outline: none;
                box-shadow: 0 0 0 1px ${tokens_1.COLOURS.greyscale.metal}, 0 0 0 3px ${tokens_1.COLOURS.greyscale.white},
                    0 0 0 5px ${tokens_1.COLOURS.primary.blue[100]}`;
}}
    }

    ${({ checked, disabled }) => {
    if (checked && disabled) {
        return `
            background-color : ${tokens_1.COLOURS.greyscale.stone};
            border: ${tokens_1.BORDERS.normal.silver};
            `;
    }
    if (disabled && !checked) {
        return `border: ${tokens_1.BORDERS.normal.silver}`;
    }
    if (checked) {
        return `
            background-color : ${tokens_1.COLOURS.primary.blue[130]};
            border: ${tokens_1.BORDERS.normal.blue};
            `;
    }
    return null;
}}
`;
exports.StyledInnerText = styled_components_1.default.span `
    display: inline-flex;
    align-items: center;
    margin-left: ${tokens_1.SIZES[1]};
`;
//# sourceMappingURL=Checkbox.styles.js.map